import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import NodeProjectPage from './Page';
import type { NodeProject } from '../../../types/uncinc_profile/nodes';

interface NodeProjectProps {
  entity: ImmutableEntity<NodeProject>;
  viewMode: string;
}

const NodeProjectWrapper: React.FC<NodeProjectProps> = ({ entity, viewMode }) => {
  switch (viewMode) {
    default:
      return <NodeProjectPage entity={entity} />;
  }
};

export default NodeProjectWrapper;
